// Modules every employee can access regardless of role assignment.
// Single source of truth — imported by AuthContext (runtime gate) and
// HR.js (user creation seed) so they can't drift apart.
//
// Add a path here only if it's safe for ANY authenticated employee to
// access. Sensitive modules (finance, quotations, sales data) must NOT
// be in this list — gate them per-role via moduleAccess instead.
export const UNIVERSAL_MODULES = [
  '/tasks',
  '/my-work',
  '/attendance',
  '/calendar',
  '/reminders',
  '/courier',
  '/email',
  '/salary',
  '/arey',
  '/lookbook', // brand guidelines — open to every employee by design
  '/handbook', // ERP handbook (how-to + jargon) — open to every employee by design
  '/launchpad', // full module directory — pure navigation, shows only what you can open
  '/directory', // mobile module directory — same navigation surface, phone layout
  '/msearch',   // mobile search — record results are grant-gated server-side
  '/approvals', // approvals deck — server scopes to the caller's approver role
  // 2FA enrolment is an account-level control, not a module: a user with no
  // /security grant still has to be able to enrol. Mirrors the backend's
  // UNIVERSAL_PATHS, which already lists '/two-factor' — without it here the
  // page hit Layout's "Access Denied" padlock for every non-founder.
  '/two-factor',
  // Fragrance notes — a reference lookup, not a data surface. It exists so the
  // team can answer "what is in this fragrance" themselves instead of asking
  // the founder, which only works if nobody needs a grant first. Contains the
  // supplier's published olfactive data and no pricing or formula percentages.
  '/fragrance-notes',
];
